<ng-container *ngFor="let slides of data; let i = index">
    <div class="adc-carousel" [ngClass]="data.customClass" [ngStyle]="data.customStyle">
        <ng-container *ngFor="let slide of slides.image; let j = index">
            <img
            *ngIf="j === currentSlides[i]"
            [src]="slide.url"
            class="adc-slide"
            [@slideAnimation]="slides.animationType"
            />
        </ng-container>
        <!-- controls -->
        <button class="adc-carousel-control prev" (click)="onPreviousClick(i)">
        <span class="adc-carousel-arrow left"></span>
        </button>
        <button class="adc-carousel-control next" (click)="onNextClick(i)">
        <span class="adc-carousel-arrow right"></span>
        </button>
    </div>
</ng-container>
